/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import encourIcon from 'Images/encour_icon.svg';
import factureIcon from 'Images/facture_icon.svg';
import impayeIcon from 'Images/impayé_icon.svg';
import reglementIcon from 'Images/réglement_icon.svg';
import ConfigContext from 'Shared/ConfigContext';
import useNetworkLoader from 'hooks/useNetworkLoader';
import { getDashboardData } from 'Components/Home/HomeServices';
import { formatAmount } from 'Utils/ulilities';
import KpiCard from './KpiCard';
import InfoPill from './InfoPill';
import EvolutionChart from './EvolutionChart';

const fmt = (v) => formatAmount(v || 0).trim();

/* ── Main Dashboard ──────────────────────────────────────────── */
const Dashboard = () => {
  const { callApi } = useNetworkLoader();
  const { state: { profile } } = useContext(ConfigContext);
  const [dash, setDash] = useState(null);

  useEffect(() => {
    callApi(getDashboardData, (data) => setDash(data || {}));
  }, []);

  const loading = dash === null;

  const {
    totalRegEncours = 0,
    totalImpaye = 0,
    totalNonRegle = 0,
    encours = [],
    impayes = [],
    nonRegles = [],
    totalRegEncoursPm = 0,
    totalRegEncoursHuile = 0,
    totalImpayePm = 0,
    totalNonReglePm = 0,
    totalImpayeHuile = 0,
    totalNonRegleHuile = 0,
    plafond = 0,
    plafondHuile = 0,
    monthList = [],
  } = dash || {};

  const encoursGlobal = totalImpayePm + totalNonReglePm + totalRegEncoursPm
    + totalImpayeHuile + totalNonRegleHuile + totalRegEncoursHuile;
  const encoursPm = totalImpayePm + totalNonReglePm + totalRegEncoursPm;
  const encoursH = totalImpayeHuile + totalNonRegleHuile + totalRegEncoursHuile;

  const nonReglesArr = nonRegles || [];
  const impayesArr = impayes || [];
  const encoursArr = encours || [];

  const echues = nonReglesArr.filter((i) => {
    try { return new Date(i.dateEcheance) < new Date(); } catch { return false; }
  });
  const nonEchues = nonReglesArr.filter((i) => {
    try { return new Date(i.dateEcheance) >= new Date(); } catch { return false; }
  });

  const cheques = impayesArr.filter((i) => i.type === 'CHEQUE');
  const effets = impayesArr.filter((i) => i.type !== 'CHEQUE');
  const chequesReg = encoursArr.filter((i) => i.type === 'CHEQUE');
  const effetsReg = encoursArr.filter((i) => i.type !== 'CHEQUE');

  const _nameParts = profile?.name?.trim().split(/\s+/) || [];
  const userName = _nameParts.length > 1 && _nameParts[0].length <= 3
    ? profile.name.trim()
    : (_nameParts[0] || '');

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#F8FAFC', pt: '90px', px: { xs: '16px', md: '40px' }, pb: '40px', mt: '-80px', '& *': { fontFamily: "'Open Sans', sans-serif !important" } }}>

      {/* Greeting header */}
      <Box
        sx={{
          backgroundColor: '#fff',
          border: '1px solid #D1D5DC',
          borderRadius: '12px',
          boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.06)',
          p: '16px 20px',
          mb: '16px',
          mt: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '16px',
        }}
      >
        <Box>
          <Typography sx={{ fontSize: '24px', fontWeight: 700, color: '#000000' }}>
            Bonjour{userName ? `, ${userName}` : ','}
          </Typography>
          <Typography sx={{ fontSize: '14px',fontWeight:600, color: '#717182', mt: '4px' }}>
            Voici un aperçu de votre activité.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '8px', flexWrap: 'wrap', backgroundColor: '#F8FAFC', border: '1px solid #F1F5F9', borderRadius: '8px', p: '6px 16px', alignItems: 'center' }}>
          <InfoPill label="Mode de paiement" value={profile?.payment?.name || '—'} loading={!profile?.name} />
          <Box sx={{ width: '0px', height: '50px', border: '1px solid #D1D5DC', my: '4px', mx: '4px' }} />
          <InfoPill label="Échéance pièces moteur" value={profile?.nbrJourEcheancePm ? `${profile.nbrJourEcheancePm} Jours` : '—'} loading={!profile?.name} />
          <Box sx={{ width: '0px', height: '50px', border: '1px solid #D1D5DC', my: '4px', mx: '4px' }} />
          <InfoPill label="Échéance huile" value={profile?.nbrJourEcheanceH ? `${profile.nbrJourEcheanceH} Jours` : '—'} loading={!profile?.name} />
        </Box>
      </Box>

      {/* KPI Cards */}
      <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
        <KpiCard
          loading={loading}
          icon={encourIcon}
          iconBg="#EBF5FB"
          title="Encours global"
          textColor="#007BC6"
          mainAmount={
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', flexWrap: 'wrap', gap: '2px' }}>
              <Box component="span" sx={{ fontSize: '18px', fontWeight: 700, color: '#000' }}>{fmt(encoursGlobal)} DHS</Box>
              <Box component="span" sx={{ fontSize: '11px', fontWeight: 700, color: '#000' }}>/{fmt(plafond + plafondHuile)} DHS</Box>
            </Box>
          }
          mainSub={
            <Typography sx={{ fontSize: '10px', fontWeight: 500, mb: '14px' }}>
              <Box component="span" sx={{ color: '#027BC6' }}>Encours</Box>
              {" = "}
              <Box component="span" sx={{ color: '#FEA26F' }}>FNR</Box>
              {" + "}
              <Box component="span" sx={{ color: '#EF456E' }}>IMP</Box>
              {" + "}
              <Box component="span" sx={{ color: '#8050BB' }}>REC</Box>
            </Typography>
          }
          row1Label="Encours PM"
          row1Value={`${fmt(encoursPm)} Dhs/${fmt(plafond)} Dhs`}
          row2Label="Encours H"
          row2Value={`${fmt(encoursH)} Dhs/${fmt(plafondHuile)} Dhs`}
        />

        <KpiCard
          loading={loading}
          icon={factureIcon}
          iconBg="#FFF3E0"
          iconColor="#F79F1F"
          badge={echues.length || null}
          title="Factures non réglées"
          textColor="#FEA26F"
          mainAmount={`${fmt(totalNonRegle)} DHS`}
          row1Label={`${echues.length} factures échues`}
          row1Value={`${fmt(echues.reduce((s, i) => s + (i.amount || 0), 0))} Dhs`}
          row2Label={`${nonEchues.length} factures non échues`}
          row2Value={`${fmt(nonEchues.reduce((s, i) => s + (i.amount || 0), 0))} Dhs`}
        />

        <KpiCard
          loading={loading}
          icon={impayeIcon}
          iconBg="#FEF2F2"
          iconColor="#EF4444"
          title="Impayés"
          textColor="#EF446E"
          mainAmount={`${fmt(totalImpaye)} DHS`}
          row1Label={`${cheques.length} chèques`}
          row1Value={`${fmt(cheques.reduce((s, i) => s + (i.amount || 0), 0))} Dhs`}
          row2Label={`${effets.length} effets`}
          row2Value={`${fmt(effets.reduce((s, i) => s + (i.amount || 0), 0))} Dhs`}
        />

        <KpiCard
          loading={loading}
          icon={reglementIcon}
          iconBg="#F3E8FF"
          iconColor="#9333EA"
          title="Règlements en cours"
          textColor="#8050BB"
          mainAmount={`${fmt(totalRegEncours)} DHS`}
          row1Label={`${chequesReg.length} chèques`}
          row1Value={`${fmt(chequesReg.reduce((s, i) => s + (i.amount || 0), 0))} Dhs`}
          row2Label={`${effetsReg.length} effets`}
          row2Value={`${fmt(effetsReg.reduce((s, i) => s + (i.amount || 0), 0))} Dhs`}
        />
      </Box>

      {/* Chart */}
      <EvolutionChart monthList={monthList} loading={loading} />
    </Box>
  );
};

export default Dashboard;
